<template>
  <div class="navigation-back-link">
    <NuxtLink
      :to="localePath(props.link.route)"
      class="text"
      :class="{
        '--light': props.light,
        '--diagonal': props.diagonal,
      }"
    >
      <img
        :src="props.light ? arrowLight : arrowDark"
        :alt="
          props.light ? 'Ico arrow forward light' : 'Ico arrow forward dark'
        "
        width="16"
        height="14"
      />
      <span>{{ props.link.title }}</span>
    </NuxtLink>
  </div>
</template>

<script>
export default {
  name: 'NavigationBackLink',
}
</script>

<script setup>
import { NuxtLink } from '#components'

import arrowLight from '~/assets/img/ico/ico-arrow-forward-light.svg'
import arrowDark from '~/assets/img/ico/ico-arrow-forward-grey.svg'

const props = defineProps({
  light: Boolean,
  link: Object,
})
</script>

<style lang="scss">
@import './style.scss';
</style>
